import axiosInstance from './axiosInstance';
import { AcademicYear } from '../types/AcademicYearTypes';
import { ApiResponse } from 'types/apiTypes';

export const getAcademicYears = async () => {
  const response = await axiosInstance.get<ApiResponse<AcademicYear[]>>('/reference/academic-years');
  return response.data.data
};



